import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
  typography: {
    fontFamily: ["Ubuntu", "sans-serif"].join(","),
    allVariants: {
      color: "#212121",
    },
  },

  palette: {
    common: {
      main: "#656565",
    },
    primary: {
      main: "#1d9e5e",
    },
    secondary: {
      main: "#EC8914",
    },
    black: {
      main: "#212121",
    },
    info: {
      main: "#0288d1",
    },
    error: {
      main: "#ef5350",
    },

    success: {
      light: "#388e3c",
      main: "#1d9e5e",
      dark: "#1b5e20",
    },
    grey: {
      light: "#e0e0e0",
      main: "#bdbdbd",
      dark: "#9e9e9e",
    },
    background: {
      default: "#f6f6f6",
    },
  },
  shape: {
    borderRadius: 12,
  },
});

export default Theme;
